import './app-chunk-vendor-modules-m0hYGuxH.js';
import { t as topbar } from './app-bundle.vendor.js';
import { o as onReady, ag as identifyCustomer, ah as initImages, ai as initTabbedMenus, aj as initSliders, ak as initForms, al as initToggleWidget, am as initDropdowns, an as initCountrySelector, ao as setConsentVariablesFromCookie, ap as storeUTM, aq as initPageSpecificEvents, a5 as isMobile } from './app-chunk-common-BPZAsnhF.js';

// Import lazysize and plugins

// @ts-ignore
delete Hammer.defaults.cssProps.userSelect;
window.Hammer = Hammer;

window.APP_BUILD_ENV = "production";

topbar.config({
  barColors: { 0: "#1556af" },
  shadowColor: "rgba(0, 0, 0, .3)",
});

const versionElement = document.querySelector("meta[name='appversion']");
if (versionElement) {
  console.log(versionElement.content);
}

window.JS_SCRIPTS_LOADED = {};

const loadJS = function (sectionEl, jsFile) {
  sectionEl.classList.add("is-section-entered");
  if (jsFile === "" || window.JS_SCRIPTS_LOADED[jsFile] === true) {
    return;
  }

  window.JS_SCRIPTS_LOADED[jsFile] = true;
  const tag = document.createElement("script");
  tag.src = jsFile;

  if (document.body.classList.contains("is-modules")) {
    tag.type = "module";
  }
  tag.defer = true;
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

const initLazyJSIntersections = () => {
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        const jsFile = entry.target.dataset.lazyJs;
        loadJS(entry.target, jsFile);
      }
    });
  });

  document.querySelectorAll("section[data-lazy-js]").forEach((section) => {
    observer.observe(section);
  });
};

const initFooter = function () {
  $(".footer__block-title").click(function () {
    if (!isMobile()) {
      return;
    }

    if ($(this).hasClass("is-open")) {
      $(this).next().slideUp();
      $(this).removeClass("is-open");
    } else {
      $(".footer__block-links-wrapper").hide();
      $(this).next().slideDown();
      $(this).addClass("is-open");
    }
  });
};

onReady(() => {
  // First
  identifyCustomer();

  initImages();
  initTabbedMenus();
  initSliders();
  initForms();
  initToggleWidget();
  initDropdowns();
  initCountrySelector();
  setConsentVariablesFromCookie();
  storeUTM();
  initPageSpecificEvents();
  initLazyJSIntersections();
  initFooter();
});
